var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68.035484mm",
    height: "56.69651mm",
    viewBox: "0 0 68.035484 56.69651",
    id: "svg54",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs51"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-45.973236,-201.29092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 114.00872,249.48293 v 5.66975 c 0,1.5502 -1.28455,2.83475 -2.83474,2.83475 H 48.807982 c -1.550194,0 -2.834746,-1.28455 -2.834746,-2.83475 v -5.66975 c 0,-1.5502 1.284552,-2.83475 2.834746,-2.83475 h 62.365998 c 1.55019,0 2.83474,1.28455 2.83474,2.83475 z m 0,-22.6785 v 5.66976 c 0,1.55019 -1.28455,2.83474 -2.83474,2.83474 H 48.807982 c -1.550194,0 -2.834746,-1.28455 -2.834746,-2.83474 v -5.66976 c 0,-1.55019 1.284552,-2.83475 2.834746,-2.83475 h 62.365998 c 1.55019,0 2.83474,1.28456 2.83474,2.83475 z m 0,-22.67876 v 5.66976 c 0,1.55019 -1.28455,2.83474 -2.83474,2.83474 H 48.807982 c -1.550194,0 -2.834746,-1.28455 -2.834746,-2.83474 v -5.66976 c 0,-1.55019 1.284552,-2.83475 2.834746,-2.83475 h 62.365998 c 1.55019,0 2.83474,1.28456 2.83474,2.83475 z",
    id: "path4",
    style: {
      strokeWidth: 0.264583
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/bars.71d1613035eda40d4fe93f3fe377885a.svg";
export { ForwardRef as ReactComponent };